export interface NewCaseValidatorResult {
    success: boolean;
    errors: string[];
}

export interface NewCaseValidatorInput {
    today: Date;
    reminderNoticeDate: Date;
    minDateOfReminder: Date;
    isFirm: boolean;
    debtorHasReminderWithPaymentDeadline: boolean;
    debtorHasReminderIncludedFee: boolean;
    hasDebtCollectionNoticeEUFee: boolean;
    hasReminderWithCustomDaysPayment: boolean;
    reminderPaymentDays: number;
    applyEUFee14DayPaymentRule: boolean;
}

export interface NewCaseValidators {
    checkReminderNotice(input: NewCaseValidatorInput): NewCaseValidatorResult;
    checkReminderNoticePerson(input: NewCaseValidatorInput): NewCaseValidatorResult;
}

export interface InvoiceReminderFields {
    dueDate?: Date | null;
    customerReminderFee?: number | null;
    customerReminderDueDate?: Date | null;
}

export interface InvoiceReminderContext {
    today: Date;
    isFirm: boolean;
    hasDebtCollectionNoticeEUFee: boolean;
    hasReminderWithCustomDaysPayment: boolean;
    reminderPaymentDays: number;
    applyEUFee14DayPaymentRule: boolean; maxCustomerReminderFee: number;
}

export interface InvoiceReminderDateBounds {
    min: Date | null;
    max: Date;
}

export class NewCaseValidatorsDenmark implements NewCaseValidators {
    checkReminderNotice(input: NewCaseValidatorInput): NewCaseValidatorResult {
        let {
            isFirm,
            debtorHasReminderWithPaymentDeadline,
            debtorHasReminderIncludedFee,
            hasDebtCollectionNoticeEUFee,
            today
        } = input;

        const noticeDate = new Date(input.reminderNoticeDate);
        const noticeDatePlusDays = new Date(noticeDate);
        const invoiceDueDate = new Date(input.minDateOfReminder);
        const dueDatePlusDays = new Date(invoiceDueDate);
        const dueDate = new Date(invoiceDueDate);

        dueDate.setDate(dueDate.getDate() - 1)
        dueDatePlusDays.setDate(dueDatePlusDays.getDate() + input.reminderPaymentDays);
        noticeDatePlusDays.setDate(noticeDatePlusDays.getDate() + input.reminderPaymentDays);

        let hasNoticeDatePassed = noticeDate.getTime() <= dueDate.getTime();
        let hasNoticeDatePlusRequiredDaysPassed = noticeDatePlusDays.getTime() > today.getTime();
        let hasNoticeDatePassedRequiredDays = noticeDate.getTime() > dueDate.getTime();

        let output: NewCaseValidatorResult = {
            success: true,
            errors: []
        };


        if (!isFirm) {
            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !debtorHasReminderIncludedFee && !hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {
            if (hasNoticeDatePassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateAfterInvoiceDueDate');
                output.success = false;
                return output;
            }

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && debtorHasReminderIncludedFee && !hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {

            if (hasNoticeDatePassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithin14DaysOfDueDate');
                output.success = false;
                return output;
            }

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithin14DaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && hasDebtCollectionNoticeEUFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !hasDebtCollectionNoticeEUFee && debtorHasReminderIncludedFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if (hasNoticeDatePlusRequiredDaysPassed || !hasNoticeDatePassedRequiredDays) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !hasDebtCollectionNoticeEUFee && !debtorHasReminderIncludedFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if (hasNoticeDatePlusRequiredDaysPassed || !hasNoticeDatePassedRequiredDays) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        output.success = true;
        output.errors = [];
        return output;
    }

    checkReminderNoticePerson(input: NewCaseValidatorInput): NewCaseValidatorResult {
        let {
            isFirm,
            debtorHasReminderWithPaymentDeadline,
            debtorHasReminderIncludedFee,
            reminderNoticeDate,
            minDateOfReminder,
            today
        } = input;

        let output: NewCaseValidatorResult = {
            success: true,
            errors: []
        };

        const noticeDate = new Date(reminderNoticeDate);
        const noticeDatePlusDays = new Date(noticeDate);
        const invoiceDueDate = new Date(minDateOfReminder);
        const dueDatePlusDays = new Date(invoiceDueDate);

        dueDatePlusDays.setDate(dueDatePlusDays.getDate() + input.reminderPaymentDays);
        noticeDatePlusDays.setDate(noticeDatePlusDays.getDate() + input.reminderPaymentDays);

        if (!isFirm && debtorHasReminderWithPaymentDeadline && !debtorHasReminderIncludedFee) {

            if (noticeDate.getTime() <= invoiceDueDate.getTime()) {
                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDateAfterInvoiceDueDate');
                output.success = false;
                return output;
            }

            if (noticeDatePlusDays.getTime() > today.getTime()) {

                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (!isFirm && debtorHasReminderWithPaymentDeadline && debtorHasReminderIncludedFee) {
            if (noticeDatePlusDays.getTime() > today.getTime()) {

                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        output.success = true;
        output.errors = [];
        return output;
    }
}

export class NewCaseValidatorsFinland implements NewCaseValidators {
    checkReminderNotice(input: NewCaseValidatorInput): NewCaseValidatorResult {
        let {
            isFirm,
            debtorHasReminderWithPaymentDeadline,
            debtorHasReminderIncludedFee,
            hasDebtCollectionNoticeEUFee,
            today
        } = input;

        const noticeDate = new Date(input.reminderNoticeDate);
        const noticeDatePlusDays = new Date(noticeDate);
        const invoiceDueDate = new Date(input.minDateOfReminder);
        const dueDatePlusDays = new Date(invoiceDueDate);
        const dueDate = new Date(invoiceDueDate);

        dueDate.setDate(dueDate.getDate() - 1)
        dueDatePlusDays.setDate(dueDatePlusDays.getDate() + input.reminderPaymentDays);
        noticeDatePlusDays.setDate(noticeDatePlusDays.getDate() + input.reminderPaymentDays);

        let hasNoticeDatePassed = noticeDate.getTime() <= dueDate.getTime();
        let hasNoticeDatePlusRequiredDaysPassed = noticeDatePlusDays.getTime() > today.getTime();
        let hasNoticeDatePassedRequiredDays = noticeDate < dueDatePlusDays;

        let output: NewCaseValidatorResult = {
            success: true,
            errors: []
        };

        if (!isFirm) {
            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !debtorHasReminderIncludedFee && !hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {
            if (hasNoticeDatePassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateAfterInvoiceDueDate');
                output.success = false;
                return output;
            }

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && debtorHasReminderIncludedFee && !hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {

            if (hasNoticeDatePassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithin14DaysOfDueDate');
                output.success = false;
                return output;
            }

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithin14DaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && hasDebtCollectionNoticeEUFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if (hasNoticeDatePlusRequiredDaysPassed) {
                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !hasDebtCollectionNoticeEUFee && debtorHasReminderIncludedFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if ((hasNoticeDatePlusRequiredDaysPassed) || (hasNoticeDatePassedRequiredDays)) {
                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !hasDebtCollectionNoticeEUFee && !debtorHasReminderIncludedFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if (hasNoticeDatePlusRequiredDaysPassed) {
                output.errors.push('NewCase.Step2.DebtCollectionNoticeMustBeOverdue');
                output.success = false;
                return output;
            }

            if (hasNoticeDatePassedRequiredDays) {
                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        output.success = true;
        output.errors = [];
        return output;
    }

    checkReminderNoticePerson(input: NewCaseValidatorInput): NewCaseValidatorResult {
        let {
            isFirm,
            debtorHasReminderWithPaymentDeadline,
            debtorHasReminderIncludedFee,
            reminderNoticeDate,
            minDateOfReminder,
            today
        } = input;

        let output: NewCaseValidatorResult = {
            success: true,
            errors: []
        };

        const noticeDate = new Date(reminderNoticeDate);
        const noticeDatePlus14Days = new Date(noticeDate);
        const invoiceDueDate = new Date(minDateOfReminder);
        const dueDatePlus14Days = new Date(invoiceDueDate);

        dueDatePlus14Days.setDate(dueDatePlus14Days.getDate() + 14);
        noticeDatePlus14Days.setDate(noticeDatePlus14Days.getDate() + 14);

        if (!isFirm && debtorHasReminderWithPaymentDeadline && !debtorHasReminderIncludedFee) {

            if (noticeDate.getTime() <= invoiceDueDate.getTime()) {
                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDateAfterInvoiceDueDate');
                output.success = false;
                return output;
            }

            if (noticeDatePlus14Days.getTime() > today.getTime()) {

                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (!isFirm && debtorHasReminderWithPaymentDeadline && debtorHasReminderIncludedFee) {

            if (noticeDate.getTime() <= dueDatePlus14Days.getTime()) {

                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDateWithin14DaysOfDueDate');
                output.success = false;
                return output;
            }

            if (noticeDatePlus14Days.getTime() > today.getTime()) {

                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        output.success = true;
        output.errors = [];
        return output;
    }

    // Per-invoice reminder
    checkInvoiceReminder(invoice: InvoiceReminderFields, context: InvoiceReminderContext): NewCaseValidatorResult {
        const fee = invoice.customerReminderFee;

        if (fee == null) {
            return { success: true, errors: [] };
        }

        if (fee > context.maxCustomerReminderFee) {
            return { success: false, errors: ['NewCase.Step2.InvoiceReminderFeeAboveMaximum'] };
        }

        // A reminder sent without a fee (fee = 0) does not need a date
        if (invoice.customerReminderDueDate == null) {
            return fee > 0
                ? { success: false, errors: ['NewCase.Step2.InvoiceReminderDateRequired'] }
                : { success: true, errors: [] };
        }

        if (invoice.dueDate == null) {
            return { success: true, errors: [] };
        }

        const minDateOfReminder = new Date(invoice.dueDate);
        minDateOfReminder.setDate(minDateOfReminder.getDate() + (context.isFirm ? 1 : 0));

        const input: NewCaseValidatorInput = {
            today: context.today,
            reminderNoticeDate: invoice.customerReminderDueDate,
            minDateOfReminder: minDateOfReminder,
            isFirm: context.isFirm,
            debtorHasReminderWithPaymentDeadline: true,
            debtorHasReminderIncludedFee: fee > 0,
            hasDebtCollectionNoticeEUFee: context.hasDebtCollectionNoticeEUFee,
            hasReminderWithCustomDaysPayment: context.hasReminderWithCustomDaysPayment,
            reminderPaymentDays: context.reminderPaymentDays,
            applyEUFee14DayPaymentRule: context.applyEUFee14DayPaymentRule,
        };

        return context.isFirm ? this.checkReminderNotice(input) : this.checkReminderNoticePerson(input);
    }

    getInvoiceReminderDateBounds(invoice: InvoiceReminderFields, context: InvoiceReminderContext): InvoiceReminderDateBounds {
        const addDays = (date: Date, days: number) => {
            const result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        };

        const today = new Date(context.today);
        today.setHours(0, 0, 0, 0);
        const dueDate = invoice.dueDate != null ? new Date(invoice.dueDate) : null;

        if (!context.isFirm) {
            const minDays = (invoice.customerReminderFee ?? 0) > 0 ? 15 : 1;
            return { min: dueDate ? addDays(dueDate, minDays) : null, max: addDays(today, -14) };
        }

        const days = context.reminderPaymentDays;

        if (context.applyEUFee14DayPaymentRule) {
            return { min: dueDate && !context.hasDebtCollectionNoticeEUFee ? addDays(dueDate, 1) : null, max: addDays(today, -days) };
        }

        if (context.hasReminderWithCustomDaysPayment) {
            return { min: dueDate && !context.hasDebtCollectionNoticeEUFee ? addDays(dueDate, days + 1) : null, max: addDays(today, -days) };
        }

        return { min: dueDate ? addDays(dueDate, 1) : null, max: today };
    }
}

export class NewCaseValidatorsNorway implements NewCaseValidators {
    checkReminderNotice(input: NewCaseValidatorInput): NewCaseValidatorResult {
        let {
            isFirm,
            debtorHasReminderWithPaymentDeadline,
            debtorHasReminderIncludedFee,
            hasDebtCollectionNoticeEUFee,
            today
        } = input;

        const noticeDate = new Date(input.reminderNoticeDate);
        const noticeDatePlusDays = new Date(noticeDate);
        const invoiceDueDate = new Date(input.minDateOfReminder);
        const dueDatePlusDays = new Date(invoiceDueDate);
        const dueDate = new Date(invoiceDueDate);

        dueDate.setDate(dueDate.getDate() - 1)
        dueDatePlusDays.setDate(dueDatePlusDays.getDate() + input.reminderPaymentDays);
        noticeDatePlusDays.setDate(noticeDatePlusDays.getDate() + input.reminderPaymentDays);

        let hasNoticeDatePassed = noticeDate.getTime() <= dueDate.getTime();
        let hasNoticeDatePlusRequiredDaysPassed = noticeDatePlusDays.getTime() > today.getTime();
        let hasNoticeDatePassedRequiredDays = noticeDate < dueDatePlusDays;

        let output: NewCaseValidatorResult = {
            success: true,
            errors: []
        };


        if (!isFirm) {
            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !debtorHasReminderIncludedFee && !hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {
            if (hasNoticeDatePassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateAfterInvoiceDueDate');
                output.success = false;
                return output;
            }

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && debtorHasReminderIncludedFee && !hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {

            if (hasNoticeDatePassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithin14DaysOfDueDate');
                output.success = false;
                return output;
            }

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && hasDebtCollectionNoticeEUFee && input.applyEUFee14DayPaymentRule) {

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithin14DaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && hasDebtCollectionNoticeEUFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if (hasNoticeDatePlusRequiredDaysPassed) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !hasDebtCollectionNoticeEUFee && debtorHasReminderIncludedFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if ((hasNoticeDatePlusRequiredDaysPassed) || (hasNoticeDatePassedRequiredDays)) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (debtorHasReminderWithPaymentDeadline && !hasDebtCollectionNoticeEUFee && !debtorHasReminderIncludedFee && !input.applyEUFee14DayPaymentRule && input.hasReminderWithCustomDaysPayment) {

            if ((hasNoticeDatePlusRequiredDaysPassed) || (hasNoticeDatePassedRequiredDays)) {

                output.errors.push('NewCase.Step2.IsDebtCollectionCompanyNoticeDateWithinXDaysOfDueDate');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        output.success = true;
        output.errors = [];
        return output;
    }

    checkReminderNoticePerson(input: NewCaseValidatorInput): NewCaseValidatorResult {
        let {
            isFirm,
            debtorHasReminderWithPaymentDeadline,
            debtorHasReminderIncludedFee,
            reminderNoticeDate,
            minDateOfReminder,
            today
        } = input;

        let output: NewCaseValidatorResult = {
            success: true,
            errors: []
        };

        const noticeDate = new Date(reminderNoticeDate);
        const noticeDatePlus14Days = new Date(noticeDate);
        const invoiceDueDate = new Date(minDateOfReminder);
        const dueDatePlus14Days = new Date(invoiceDueDate);

        dueDatePlus14Days.setDate(dueDatePlus14Days.getDate() + 14);
        noticeDatePlus14Days.setDate(noticeDatePlus14Days.getDate() + 14);

        if (!isFirm && debtorHasReminderWithPaymentDeadline && !debtorHasReminderIncludedFee) {

            if (noticeDate.getTime() <= invoiceDueDate.getTime()) {
                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDateAfterInvoiceDueDate');
                output.success = false;
                return output;
            }

            if (noticeDatePlus14Days.getTime() > today.getTime()) {

                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        if (!isFirm && debtorHasReminderWithPaymentDeadline && debtorHasReminderIncludedFee) {

            if (noticeDate.getTime() <= dueDatePlus14Days.getTime()) {

                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDateWithin14DaysOfDueDate');
                output.success = false;
                return output;
            }

            if (noticeDatePlus14Days.getTime() > today.getTime()) {

                output.errors.push('NewCase.Step2.IsDebtCollectionNoticeDatePlus14DaysAfterToday');
                output.success = false;
                return output;
            }

            output.success = true;
            output.errors = [];
            return output;
        }

        output.success = true;
        output.errors = [];
        return output;
    }
}